import { schoolRecordPermissionApi } from '../../../api/admin/schoolRecord';
import { swalAlert, swalErrorAlert } from '../../../utils/swal/swal';

const SchoolRecordPermissionButtonGroup = ({ userId, canView }) => {
    if (!userId) return ''

    const onClickAble = async (userId) => {
        try {
            const requestData = {
                userId,
                canView: true
            }
            const result = await schoolRecordPermissionApi(requestData)
            if (result.data?.code === 200) {
                // 성공 alert
                swalAlert('열람권한 저장', '열람권한 설정을 완료하였습니다.', 'success', '확인')
            } else {
                swalAlert('열람권한 저장 실패', '열람권한 설정에 실패하였습니다.', 'error', '확인')
            }

        } catch (error) {
            // 에러 alert
            swalErrorAlert('열람권한 저장 에러', '열람권한 설정 도중 에러가 발생하였습니다.', 'error', '확인')
        }
    }

    const onClickDisable = async (userId) => {
        try {
            const requestData = {
                userId,
                canView: false
            }
            const result = await schoolRecordPermissionApi(requestData)
            if (result.data?.code === 200) {
                // 성공 alert
                swalAlert('열람권한 저장', '열람권한 설정을 완료하였습니다.', 'success', '확인')
            } else {
                swalAlert('열람권한 저장 실패', '열람권한 설정에 실패하였습니다.', 'error', '확인')
            }

        } catch (error) {
            // 에러 alert
            swalErrorAlert('열람권한 저장 에러', '열람권한 설정 도중 에러가 발생하였습니다.', 'error', '확인')
        }
    }

    const onClickNull = async (userId) => {
        try {
            const requestData = {
                userId,
                canView: null
            }
            const result = await schoolRecordPermissionApi(requestData)
            if (result.data?.code === 200) {
                // 성공 alert
                swalAlert('열람권한 저장', '열람권한 설정을 완료하였습니다.', 'success', '확인')
            } else {
                swalAlert('열람권한 저장 실패', '열람권한 설정에 실패하였습니다.', 'error', '확인')
            }
        } catch (error) {
            // 에러 alert
            swalErrorAlert('열람권한 저장 에러', '열람권한 설정 도중 에러가 발생하였습니다.', 'error', '확인')
        }
    }

    return (
        <ul className='d-flex justify-content-center gap-4' style={{ fontSize: "13px" }}>
            <li>
                <input
                    type='radio'
                    name={`permission_${userId}`}
                    id={`permissionAble_${userId}`}
                    className='form-check-input mt-0 me-1'
                    onClick={() => onClickAble(userId)}
                    defaultChecked={canView === 1}
                />
                <label htmlFor={`permissionAble_${userId}`}>열람 가능</label>
            </li>
            <li>
                <input
                    type='radio'
                    name={`permission_${userId}`}
                    id={`permissionDisable_${userId}`}
                    className='form-check-input mt-0 me-1'
                    onClick={() => onClickDisable(userId)}
                    defaultChecked={canView === 0}
                />
                <label htmlFor={`permissionDisable_${userId}`}>열람 불가능</label>
            </li>
            <li>
                <input
                    type='radio'
                    name={`permission_${userId}`}
                    id={`permissionNull_${userId}`}
                    className='form-check-input mt-0 me-1'
                    onClick={() => onClickNull(userId)}
                    defaultChecked={canView === null}
                />
                <label htmlFor={`permissionNull_${userId}`}>전역설정 따름</label>
            </li>
        </ul>
    )
}

export default SchoolRecordPermissionButtonGroup